export default "__VITE_PUBLIC_ASSET__56e0b904__"